import {
  ExpertWorkspaceRecord,
  ExpertWorkspaceSubscriptionPlanType,
} from '@libs/shared/api';

export function isImmediatePlanChange(
  currentPlanType: ExpertWorkspaceSubscriptionPlanType,
  selectedPlanType: ExpertWorkspaceSubscriptionPlanType
): boolean {
  if (!selectedPlanType) return false;

  // 개인에서 팀으로 업그레이드는 항상 즉시 변경
  return (
    currentPlanType === ExpertWorkspaceSubscriptionPlanType.Personal &&
    selectedPlanType === ExpertWorkspaceSubscriptionPlanType.Team
  );
}

export function hasExpertWorkspaceActiveSubscription(
  expertWorkspace: ExpertWorkspaceRecord
): boolean {
  if (!expertWorkspace) return false;

  const startedAt = expertWorkspace.activeSubscriptionStartedAt;
  if (!startedAt) return false;

  const now = new Date();
  const startDate = new Date(startedAt);
  if (isNaN(startDate.getTime())) return false;

  const endedAt = expertWorkspace.activeSubscriptionEndedAt;
  if (!endedAt) {
    // 종료일이 없으면 무기한 구독으로 간주
    return now >= startDate;
  }

  const endDate = new Date(endedAt);
  if (isNaN(endDate.getTime())) return false;

  return now >= startDate && now <= endDate;
}
